import type { SanityImageSizesOpt } from "../components/types/Sanity";
import { getSanityImageSrc as getSrc } from "./getSanityImageSrc";
import type { SanityClient } from "@sanity/client";

export const getSanityMetaImageObject = (
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	sanityImage: any,
	record?: { [key: string]: unknown },
	client?: SanityClient
) => {
	const id = sanityImage?.asset?._id || sanityImage?.asset?._ref || null;
	const meta: {
		imageAlt?: string | undefined | null;
	} = {};
	const imageOpt: SanityImageSizesOpt = {
		sizes: [[1200, 630]],
	};

	// get image meta values
	if (sanityImage?.alt) meta.imageAlt = sanityImage.alt;

	// add hotspot to imageOpt if hotspot is defined in sanityImage
	if (sanityImage?.hotspot) {
		imageOpt.hotspot = sanityImage.hotspot;
	}

	return {
		...meta,
		image: getSrc(
			id,
			{
				format: "jpg",
				width: 1200,
				height: 630,
				fit: "crop",
				quality: 80,
				...imageOpt,
			},
			record,
			client
		),
		imageWidth: 1200,
		imageHeight: 630,
	};
};

export default getSanityMetaImageObject;
